import { useState, useContext, useEffect } from 'react';

import {AppBar, FormControl, Box, Toolbar, IconButton, Typography, MenuItem, Divider,
  Select
} from '@mui/material';
import { AppContext } from 'core/context/';
import DashboardIcon from '@mui/icons-material/Dashboard';

const FiltersBar = ({getDashboardData}) => {
  const timeFrames = [
    {label: 'Today', value: 'TODAY'},
    {label: 'Last 7 days', value: 'LAST_7_DAYS'},
    {label: 'Last 30 days', value: 'LAST_30_DAYS'},
  ];
  const [ timeFrame, setTimeFrame ] = useState(timeFrames[0].value);
  const [libraryList, setLibrayList] = useState([]);
  const [librarySelected, setLibraySelected] = useState('');

  const { libraries } = useContext(AppContext);
  
  useEffect(() => {
    if(libraries?.length){
      setLibrayList(libraries);
      setLibraySelected(libraries[0]);
    }
  }, [libraries]);

  useEffect(() => {
    if(librarySelected && timeFrame){
      const data = {librarySelected, timeFrame}
      getDashboardData({...data})
    }
  }, [getDashboardData, librarySelected, timeFrame]);


  /* Functions */
 

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" component="div" color="white" sx={{minHeight: '48px', maxHeight: '48px', boxShadow: 'none', border: 'solid #f4f4f4'}} >
        <Toolbar sx={{minHeight: '48px !Important', maxHeight: '48px'}}>
          <IconButton
            size="small"
            edge="start"
            // color="inherit"
            aria-label="Dashboard"
            sx={{ mr: 2 }}
          >
            <DashboardIcon fontSize="inherit"/>
          </IconButton>
          <Typography
            noWrap
            component="div"
            variant="overline"
            sx={{ display: { xs: 'none', sm: 'block' } }}
          >
            Dashboard
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{display: 'flex'}} alignItems="center">
            <FormControl sx={{fontSize: 12}}>
              <Select 
                size="small"
                labelId="library-select-label"
                value={librarySelected}
                label="Library"
                variant="standard"
                onChange={(e) => setLibraySelected(e.target.value)}
                sx={{ padding: '4px 0 1px', fontSize: 14 }}
                disableUnderline
              >
                {libraryList.map((library, index) => <MenuItem key={index} value={library}>{library.name}</MenuItem>)}
              </Select>
            </FormControl>
            <Divider sx={{ height: 28, my: 0.5, mx: 1.5 }} orientation="vertical" />
            <FormControl sx={{ borderBottom: 'none '}}>
              <Select 
                size="small"
                labelId="timeFrame-select-label"
                value={timeFrame}
                label="timeFrame"
                variant="standard"
                onChange={(e) => setTimeFrame(e.target.value)}
                sx={{ padding: '4px 0 1px',fontSize: 14 }}
                disableUnderline
              >
                {timeFrames.map((time, index) => <MenuItem key={index} value={time.value}>{time.label}</MenuItem>)}
              </Select>
            </FormControl>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
 
export default FiltersBar;
